import React, { useRef } from "react";
import { useTranslation } from 'react-i18next';
import {
    Box,
    Button,
    Container,
    Grid,
    Link,
    Typography
} from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Tabs from './Tabs'
import ProductCard from '../ProductCard'
import { useScreenDetector } from '../../hooks/useScreenDetector'

const CardsTab = ({ tabData }) => {
    const { t } = useTranslation('home');
    const { isMobile } = useScreenDetector()
    const initialCards = isMobile
        ? tabData[0].data.slice(0, 4)
        : tabData[0].data

    const [activeTabIndex, setActiveTabIndex] = React.useState(0)
    const [currentCards, setCurrentCards] = React.useState(initialCards)

    // Sincroniza currentCards cuando tabData, isMobile o activeTabIndex cambian
    React.useEffect(() => {
        if (tabData && tabData.length > 0) {
            if (isMobile) {
                setCurrentCards(tabData[activeTabIndex].data.slice(0, 4));
            } else {
                setCurrentCards(tabData[activeTabIndex].data);
            }
        }
    }, [tabData, isMobile, activeTabIndex]);

    const onChangeTab = (tabIndex) => (evt, value) => {
        const tab = tabIndex !== undefined ? tabIndex : value
        setActiveTabIndex(tab)
        if (isMobile) {
            const mobileCards = tabData[tab].data.slice(0, 4)
            setCurrentCards([...mobileCards])
        } else {
            setCurrentCards([...tabData[tab].data])
        }
    }

    const carouselRef = useRef(null);

    const scrollLeft = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({
                left: -300, // ajusta el valor al tamaño de tus cards
                behavior: "smooth"
            });
        }
    };

    const scrollRight = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({
                left: 300,
                behavior: "smooth"
            });
        }
    };

    return (
        <Box>
            <Container>
                <Grid container mb={1.5}>
                    <Grid item xs={12} md={9}>
                        <Typography
                            color="secondary"
                            variant="subtitle"
                            component="h2"
                            sx={{ fontSize: { xs: '20px', md: '24px' } }}>
                            {t('favoriteTours-title')}
                        </Typography>
                        <Typography
                            variant="body1"
                            component="p"
                            sx={{
                                textAlign: { xs: 'center', md: 'left' },
                            }}
                        >
                            {t('favoriteTours-subtext')}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        justifyContent="flex-end"
                        alignItems="center"
                        sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <Button
                            variant="contained"
                            color="primary"
                            href={`/${t('destinations')}`}
                            className="animated-button"
                        >
                            <span className="button-text">{t('favoriteTours-button')}</span>
                            <span className="button-arrow">
                                <ChevronRightIcon fontSize="large" />
                            </span>
                        </Button>
                    </Grid>
                </Grid>
                {/* <Tabs
                    tabs={tabData}
                    activeTab={activeTabIndex}
                    onChangeTab={onChangeTab}
                /> */}
            </Container>
            {isMobile ? (
                <Grid container spacing={1} sx={{ my: '1.5rem', px: '1rem' }}>
                    {currentCards.map((tab, index) => (
                        <Grid key={`${tab.title}${index}`} item xs={6}>
                            <ProductCard {...tab} />
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Box className="carousel-container"
                    sx={{
                        display: 'flex',
                        overflowX: 'auto',
                    }}
                >
                    <IconButton
                        onClick={scrollLeft}
                        style={{
                            position: "absolute",
                            left: "0.5rem",
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 1,
                            color: "#ffffff",
                            backgroundColor: "#29c5f6"
                        }}
                    >
                        <ArrowBackIosNewIcon />
                    </IconButton>

                    <ul
                        ref={carouselRef}
                        className="desktop-carousel"
                        style={{
                            display: "flex",
                            overflowX: "auto",
                            scrollBehavior: "smooth",
                            listStyle: "none",
                            margin: 0
                        }}
                    >
                        {currentCards.map((tab, index) => (
                            <li
                                key={`${tab.title}${index}`}
                                style={{
                                    marginRight: "1rem",
                                    marginLeft: index === 0 ? "1.5rem" : "0", // Espacio solo al primer ítem
                                    flex: "0 0 auto"
                                }}
                            >
                                <ProductCard {...tab} />
                            </li>
                        ))}
                    </ul>

                    <IconButton
                        onClick={scrollRight}
                        style={{
                            position: "absolute",
                            right: "0.5rem",
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 1,
                            color: "#ffffff",
                            backgroundColor: "#29c5f6"
                        }}
                    >
                        <ArrowForwardIosIcon />
                    </IconButton>
                </Box>
            )}
            <Box
                sx={{
                    display: { xs: 'flex', md: 'none' },
                    justifyContent: 'center',
                    my: '3rem'
                }}>
                <Link
                    color="primary"
                    underline="none"
                    sx={{
                        fontSize: 20,
                        fontFamily: 'Poppins',
                        fontWeight: 700,
                        lineHeight: 1.5
                    }}
                    href={`/${t('destinations')}`}
                >

                    {t('favoriteTours-button')}
                </Link>
            </Box>
        </Box>
    )
}

export default CardsTab
